import {useMutation} from 'react-query';
import {queryApi} from '~/utils';

export function useSignout() {
  const {data, isSuccess, mutateAsync, ...props} = useMutation(
    async () => {
      const res = await signOutApiCall();
      return res;
    },
    {
      retry: false,
    },
  );

  return {data, isSuccess, signOut: mutateAsync, ...props} as const;
}

export const signOutApiCall = async (): Promise<Response> => {
  const res = await queryApi({
    method: 'DELETE',
    url: '/cookies',
  });

  return res;
};
